// extracted by mini-css-extract-plugin
export default {"innerWrapper":"TA-z","tooltipWrapper":"UA-z","icon":"VA-z","tooltip":"WA-z","content":"XA-z"};